import { Autocomplete, Box, Button, Grid2, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { GoogleMap, useJsApiLoader, DirectionsRenderer, Polygon, DrawingManager } from '@react-google-maps/api';
import config from '../../config/config.js';
import React, { useEffect, useRef, useState } from "react";
import constants from '../../constant.js';
import { useLocation, useNavigate } from "react-router-dom";
import { Label } from "flowbite-react";
import DeleteIcon from '@mui/icons-material/Delete';
import lootieAnimation from '../../assets/animations/Mail Send.json';
import Lottie from "lottie-react";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const AddCity = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const location = useLocation();
    const navigate = useNavigate();

    const [mapInstance, setMapInstance] = useState(null);
    const [center,setCenter] = useState({ lat: 29.103914595786566, lng: 76.31476921014405 });
    const [cityFilter, setCityFilter] = useState("");
    const [error, setError] = useState('');

    const [allCitiesData, setAllCitiesData] = useState([]);
    const [geofence, setGeofence] = useState([]);
    const [noCityMatch, setNoCityMatch] = useState(false);
    const [cityName, setCityName] = useState('');
    const [currency, setCurrency] = useState('');
    const [drawingMode, setDrawingMode] = useState(false);
    const [polygonPath, setPolygonPath] = useState([]);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [isPolygonVisible, setIsPolygonVisible] = useState(true);
    const [drawnPolygon, setDrawnPolygon] = useState(null);
    const [utcOffset, setUtcOffset] = useState('');
    const [latlng, setLatLng] = useState('');
    const [shortCountryName, setShortCountryName] = useState('');
    const [customSquareGeofence, setCustomSquareGeofence] = useState([]);
    const [updateGeofence, setUpdateGeofence] = useState(false);
    const [modifyGeofence, setModifyGeofence] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [geofenceModification, setGeofenceModification] = useState(false);

    const currencyList = [
        { code: "USD", name: "United States Dollar", symbol: "$" },
        { code: "EUR", name: "Euro", symbol: "€" },
        { code: "GBP", name: "British Pound", symbol: "£" },
        { code: "INR", name: "Indian Rupee", symbol: "₹" },
        { code: "SAR", name: "Saudi Riyal", symbol: "﷼" },
        { code: "AED", name: "United Arab Emirates Dirham", symbol: "د.إ" },
        { code: "JPY", name: "Japanese Yen", symbol: "¥" },
        { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
        { code: "AUD", name: "Australian Dollar", symbol: "A$" },
        { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
        { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
        { code: "SEK", name: "Swedish Krona", symbol: "kr" },
        { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
        { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
        { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
        { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
        { code: "KRW", name: "South Korean Won", symbol: "₩" },
        { code: "BRL", name: "Brazilian Real", symbol: "R$" },
        { code: "ZAR", name: "South African Rand", symbol: "R" },
        { code: "TRY", name: "Turkish Lira", symbol: "₺" },
        { code: "RUB", name: "Russian Ruble", symbol: "₽" },
        { code: "MXN", name: "Mexican Peso", symbol: "$" },
        { code: "THB", name: "Thai Baht", symbol: "฿" },
        { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
        { code: "PHP", name: "Philippine Peso", symbol: "₱" },
        { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
        { code: "EGP", name: "Egyptian Pound", symbol: "E£" },
        { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
        { code: "QAR", name: "Qatari Riyal", symbol: "﷼" },
        { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك" },
        { code: "OMR", name: "Omani Rial", symbol: "﷼" },
        { code: "BHD", name: "Bahraini Dinar", symbol: "د.ب" }
    ];
    
    const countryCurrencyMapping = [
        { country: 'US', currencyCode: 'USD', currencySymbol: '$' },
        { country: 'GB', currencyCode: 'GBP', currencySymbol: '£' },
        { country: 'EU', currencyCode: 'EUR', currencySymbol: '€' },
        { country: 'IN', currencyCode: 'INR', currencySymbol: '₹' },
        { country: 'JP', currencyCode: 'JPY', currencySymbol: '¥' },
        { country: 'SA', currencyCode: 'SAR', currencySymbol: '﷼' },
        { country: 'AE', currencyCode: 'AED', currencySymbol: 'د.إ' },
        { country: 'AU', currencyCode: 'AUD', currencySymbol: 'A$' },
        { country: 'CA', currencyCode: 'CAD', currencySymbol: 'C$' },
        { country: 'CN', currencyCode: 'CNY', currencySymbol: '¥' },
        { country: 'SG', currencyCode: 'SGD', currencySymbol: 'S$' },
        { country: 'CH', currencyCode: 'CHF', currencySymbol: 'CHF' },
        { country: 'KR', currencyCode: 'KRW', currencySymbol: '₩' },
        { country: 'RU', currencyCode: 'RUB', currencySymbol: '₽' },
        { country: 'BR', currencyCode: 'BRL', currencySymbol: 'R$' },
        { country: 'ZA', currencyCode: 'ZAR', currencySymbol: 'R' },
        { country: 'MX', currencyCode: 'MXN', currencySymbol: '$' },
        { country: 'TH', currencyCode: 'THB', currencySymbol: '฿' },
        { country: 'MY', currencyCode: 'MYR', currencySymbol: 'RM' },
        { country: 'NZ', currencyCode: 'NZD', currencySymbol: 'NZ$' },
        { country: 'TR', currencyCode: 'TRY', currencySymbol: '₺' },
        { country: 'EG', currencyCode: 'EGP', currencySymbol: '£' },
        { country: 'ID', currencyCode: 'IDR', currencySymbol: 'Rp' },
        { country: 'PH', currencyCode: 'PHP', currencySymbol: '₱' },
        { country: 'PK', currencyCode: 'PKR', currencySymbol: '₨' },
        { country: 'VN', currencyCode: 'VND', currencySymbol: '₫' },
        { country: 'NG', currencyCode: 'NGN', currencySymbol: '₦' },
        { country: 'HK', currencyCode: 'HKD', currencySymbol: 'HK$' },
        { country: 'KW', currencyCode: 'KWD', currencySymbol: 'د.ك' },
        { country: 'QA', currencyCode: 'QAR', currencySymbol: '﷼' },
    ];
    
    const clientId = localStorage.getItem('clientId');
    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const drawingManagerRef = useRef(null);

    const containerStyle = {
        width: '100%',
        height: '580px',
    };

    const containerStyle2 = {
        width: '100%',
        height: '450px',
    };

    const onLoad = (map) => {
        setMapInstance(map);
    };

    const onUnmount = () => {
        setMapInstance(null);
        console.log("Google Map unmounted.");
    };

    useEffect(() => {
        return () => {
            setMapInstance(null);
            // fetchCitiesData();
        };
    }, []);

    // useEffect(() => {
    //     if (mapInstance&& geofence && geofence.length > 0) {
    //         const bounds = new window.google.maps.LatLngBounds();
    //         geofence.forEach((point) =>
    //             bounds.extend({ lat: point.x, lng: point.y })
    //         );
    //         mapInstance.fitBounds(bounds);
    //     }
    // }, [geofence]);

    useEffect(() => {
        if (mapInstance && window.google && window.google.maps && geofence.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            geofence.forEach((polygon) => {
                polygon.forEach((point) => {
                    bounds.extend({ lat: point.x || point.lat, lng: point.y || point.lng });
                });
            });
            mapInstance.fitBounds(bounds);
        }
    }, [geofence]);

    const handleCityChange = (e) => {
        const selectedCityId = e;
        setCityFilter(e);
        const foundCity = allCitiesData.find(city => city.city_id === Number(selectedCityId));
    
        if (foundCity) {
            setGeofence(foundCity.geofence)
        } else {
            console.warn("City not found in allCitiesData.");
        }
    };

    const handleUpdatePolygon = () => {
        console.log('updated');
    }

    const fetchAllCitiesData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const queryParams = new URLSearchParams({
                // city_id: cityFilter || 4,
                // token: token
                // timestamp: timestamp
            }).toString();
    
            const url = `${serverUrl}/panel/fetch_all_city?${queryParams}`;
    
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    // "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
    
            if (!response.ok) {
                throw new Error(`Failed to fetch: ${response.statusText}`);
            }
    
            const data = await response.json();
            setIsPolygonVisible(true)
            setAllCitiesData(data.data || []);
            return data.data || [];
            
        } catch (error) {
            console.error("Error fetching cities:", error);
            setError(error.message || "An error occurred. Please try again later.");
        }
    };
    
   
    useEffect(()=>{
        fetchAllCitiesData();
    },[])

    function generateSquareGeofence(centerLat, centerLng, sideLengthKm = 50) {
        const halfSide = (sideLengthKm / 2) / 111; // 1 degree = ~111km
    
        return [
            { lat: centerLat + halfSide, lng: centerLng - halfSide }, // NW
            { lat: centerLat + halfSide, lng: centerLng + halfSide }, // NE
            { lat: centerLat - halfSide, lng: centerLng + halfSide }, // SE
            { lat: centerLat - halfSide, lng: centerLng - halfSide }, // SW
            { lat: centerLat + halfSide, lng: centerLng - halfSide }  // Close the loop (back to NW)
        ];
    }

    const handleAddCity = async() => {
        // console.log('cityName = ', cityName, 'shortCountryName=', shortCountryName, 'latLng=', latlng, 'utcOffset=', utcOffset, 'currency=', currency, 'polygonPath=', polygonPath, 'geofence= ', geofence[0]);
        const found = countryCurrencyMapping.find(item => item.country === shortCountryName.toUpperCase());

        
        // const squareGeofence = generateSquareGeofence(latlng.lat, latlng.lng, 1); // 1 km square
        // setCustomSquareGeofence(squareGeofence);

        // console.log('squareGeofence = ', squareGeofence)
        try {
            if(noCityMatch){
                console.log('111111');

                if(cityName==""){
                    setMessage('Please enter City Name.');
                    showSnackbar(true);
                    return;
                }
                var body1 = {
                    client_id: clientId,
                    city_name: cityName,
                    currency: found ? found.currencyCode : '',    //currencyData.currency,
                    currency_symbol: found ? found.currencySymbol : '',     //currencyData.currency_symbol,
                    geofence: polygonPath.length>0 ? polygonPath : customSquareGeofence,  //polygonPath,
                    center_latitude: latlng.lat,  //lat/polygonPath.length,
                    center_longitude: latlng.lng, //lng/polygonPath.length
                    utc_offset: utcOffset
                };
            }
            else{
                console.log('22222222');
                let finalPath = [];
                let defGeo = false;
                
                if (polygonPath && polygonPath.length > 0) {
                    finalPath = polygonPath;
                } else if (geofence && geofence.length > 0 && geofence[0]) {
                    defGeo=true;
                    finalPath = geofence[0].map(coord => ({
                        lat: coord.y,
                        lng: coord.x,
                    }));
                } else if (customSquareGeofence && customSquareGeofence.length > 0) {
                    finalPath = customSquareGeofence;
                }

                // console.log('finalPath = ', finalPath);
                
                var body2 = {
                    client_id: clientId,
                    city_id: cityFilter
                }
                if(defGeo==false) {
                    body2.geofence = finalPath;
                }
            }

            const response = await fetch(operationsUrl + '/client/add_new_city', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: noCityMatch ? JSON.stringify(body1) : JSON.stringify(body2)
            });
            const data = await response.json();

            if (data.flag==200) {
                // fetchClientData();
                setMessage(data.message)
                showSnackbar(true);
                setUpdateGeofence(false);
                setModifyGeofence(false); 
                // window.location.href = 'https://admin-dev.mobilityinfotech.com';
                setShowSuccessModal(true);
                setTimeout(() => {
                    // Redirect to the new URL after the prompt is acknowledged or after a timeout
                    // window.location.href = 'https://admin-dev.mobilityinfotech.com';
                    navigate('/operational-cities');
                    setShowSuccessModal(false);
                }, 10000);
            } 
            else {
                setError(data.message || 'City addition failed.');
                setMessage(data.message)
                showSnackbar(true);
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    }

    const handleNoCityMatch = () => {
        console.log('new city');
        setNoCityMatch(true);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handlePolygonClick = () => {
        // Toggle selection
        // console.log('true', geofence[0], selectedPolygon, customSquareGeofence)
        setSelectedPolygon(customSquareGeofence ? customSquareGeofence : geofence[0]);
    };

    // const handleDeletePolygon = () => {
    //     setIsPolygonVisible(false);
    //     setSelectedPolygon(null);  // Reset the selection
    // };

    const handleDeletePolygon = () => {
        if (drawnPolygon || customSquareGeofence) {
            // setIsPolygonVisible(false);
            if(drawnPolygon) drawnPolygon.setMap(null);  // This removes polygon from map
            setDrawnPolygon(null);      // Clear reference
            setCustomSquareGeofence([])
            setGeofence([]);
            setPolygonPath([]);         // Clear coordinates
        } else {
            console.warn("No polygon selected for deletion.");
        }
    };

    const onLoadDrawingManager = (drawingManager) => {
        drawingManagerRef.current = drawingManager;
    };

    const onPolygonComplete = (polygon) => {
        const path = polygon.getPath().getArray();
        const coordinates = path.map(latLng => ({
            lat: latLng.lat(),
            lng: latLng.lng(),
        }));
        setPolygonPath(coordinates);
        setGeofence([]);
        setDrawnPolygon(polygon);
        setDrawingMode(false);  // Disable drawing mode after polygon is drawn
    };

    const handleDrawPolygon = () => {
        if (!isLoaded || !window.google) {
            console.error("Google Maps API not loaded yet");
            return;
        }
        // Check if any polygon exists
        if (drawnPolygon || customSquareGeofence?.length || geofence?.length || polygonPath?.length) {
            setMessage('Delete the existing polygon before drawing a new one.');
            showSnackbar(true);
            return;
        }
        setDrawingMode(true);
        if (drawingManagerRef.current) {
            drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
        }
    };
    const inputRef = useRef(null);

    useEffect(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
            const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['(cities)'], // Only city names
                // componentRestrictions: { country: 'IN' },
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                console.log('place==', place.geometry.location.lat());

                setCityName(place.name);
                setUtcOffset(place.utc_offset);
                setGeofenceModification(true);
                if (place.geometry) {
                    setLatLng({
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    });
                }
                for(let i=0;i<place.address_components.length;i++){
                    if(place.address_components[i].types.includes("country")){
                        console.log('country');
                        setShortCountryName(place.address_components[i].short_name)
                    }
                }
                // if (place.geometry) {
                //     setCityName(place.formatted_address || '');
                // }
                
            });
        } else {
            console.error('Google Maps script is not loaded. Make sure the script is included.');
        }
    }, [cityName]);

    useEffect(()=>{
        if (latlng && latlng.lat && latlng.lng) {
            const squareGeofence = generateSquareGeofence(latlng.lat, latlng.lng, 50); // 1 km square
            setCustomSquareGeofence(squareGeofence);
    
            setModifyGeofence(true);
            console.log('squareGeofence = ', squareGeofence)
        }
    },[latlng]);

    const handleModifyGeofence = () => {
        setUpdateGeofence(true);
        setModifyGeofence(false);
        setGeofenceModification(false);
    }
    const handleClosePopupModal = () => {
        // window.location.href = 'https://admin-dev.mobilityinfotech.com';
        navigate('/operational-cities');
        setShowSuccessModal(false);
    } 

    useEffect(() => {
        if (mapInstance && window.google && window.google.maps && customSquareGeofence.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            customSquareGeofence.forEach((point) => {
                bounds.extend({ lat: point.lat, lng: point.lng });
            });
            mapInstance.fitBounds(bounds);
        }
    }, [customSquareGeofence]);

    return(
        <div>
            {/* <Navbar/>
            <div className="App">
                <Sidemenu/>
                <div className="content"> */}
                    <Typography style={{ fontSize: '28px', fontWeight: '500', textAlign:'center', padding:'1%', border:'2px solid #f9f9f9', boxShadow:'2' }}>Add Operational City</Typography>

                    <div style={{margin:'1%'}}>
                    <Grid2 item container>
                        <Grid2 item>
                            <Autocomplete
                                options={allCitiesData} // Cities list
                                getOptionLabel={(option) => option.city_name} // Display city name
                                value={allCitiesData.find(city => city.city_id === cityFilter) || null} // Bind selected value
                                onChange={(event, newValue) => {
                                    setCityFilter(newValue ? newValue.city_id : ""); // Update selected city
                                    handleCityChange(newValue ? newValue.city_id : ""); // Call city change handler
                                    setNoCityMatch(false);
                                    setGeofenceModification(!!newValue); // Set to true when a city is selected, false otherwise
                                }}
                                onInputChange={(event, value) => {
                                    // Check if input value matches any option in the list
                                    const isMatch = allCitiesData.some(city => city.city_name.toLowerCase().includes(value.toLowerCase()));
                                    
                                    // If no match, call your function (e.g., show message or log)
                                    if (!isMatch) {
                                        handleNoCityMatch();  // Call function when no match found
                                        setGeofenceModification(false) // Set to false when no city matches
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params} 
                                        label="Select City" 
                                        variant="outlined" 
                                        sx={{
                                            width: "220px", 
                                            backgroundColor: "#FFFFFF",
                                            borderRadius: "8px"
                                        }} 
                                    />
                                )}
                                getOptionKey={(option) => option.city_id}
                            />
                        </Grid2>

                        {(geofenceModification && !noCityMatch) && (
                            <Grid2 item size={3} sx={{marginLeft:'2%', marginTop:'4px'}}>
                                    <Button
                                    onClick={handleModifyGeofence}
                                    sx={{textTransform:'none', border:'1px solid #0065ff', borderRadius:'8px', padding:'10px', height:'46px'}}
                                >
                                    Modify Geofence
                                </Button>
                            </Grid2>
                        )}

                        {(updateGeofence && !geofenceModification && !noCityMatch) && (
                            <Grid2 item size={3} sx={{marginLeft:'2%', marginTop:'4px'}}>
                                
                                    <Button
                                        onClick={handleDrawPolygon}
                                        disabled={drawnPolygon || (customSquareGeofence && customSquareGeofence.length > 0)}
                                        sx={{textTransform:'none', border:'1px solid #0065ff', borderRadius:'8px', padding:'10px', height:'46px'}}
                                    >
                                        Draw Geofence
                                    </Button>
                                

                                {(drawnPolygon || customSquareGeofence) && (
                                    <Button sx={{height:'46px', marginLeft:'4%'}}
                                        variant="contained"
                                        color="danger"
                                        onClick={handleDeletePolygon}
                                    >
                                        <DeleteIcon/>
                                    </Button>
                                )}
                            </Grid2>
                        )}

                        {!noCityMatch && (
                            <Grid2 container sx={{marginLeft:'auto'}}>
                                <Grid2 item>
                                    <Button 
                                        variant="contained" 
                                        sx={{
                                            backgroundColor: '#0065FF', 
                                            color:'#fff', 
                                            textTransform:'none', 
                                            padding:'14px 24px', 
                                            borderRadius:'8px'
                                        }} 
                                        onClick={handleAddCity}
                                    >
                                        Save City
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )}

                    </Grid2>
                    
                    {noCityMatch && (
                        <Grid2 sx={{marginTop:'4%'}}>
                            <Label>Enter your city name here if not found in the dropdown</Label>
                            <Grid2 container size={12} sx={{marginTop:'1%'}}>
                                <Grid2 item size={3}>
                                    {/* <Label>City Name<span style={{ color: 'red' }}>*</span></Label> */}
                                    <TextField inputRef={inputRef}  // Attach the ref directly to TextField input
                                        sx={{ marginTop: '1%' }} placeholder="Search City" fullWidth variant="outlined"
                                        type="text" value={cityName} onChange={(e) => setCityName(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {
                                                height: '46px',
                                                width: '280px',
                                                fontSize: '16px',
                                                padding: '8px',
                                                backgroundColor: '#FFFFFF'
                                            }
                                        }}
                                    />
                                    {/* <TextField  sx={{marginTop:'1%'}}
                                        placeholder="City Name" fullWidth variant="outlined" type="text" 
                                        value={cityName}
                                        onChange={(e) => setCityName(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {height: '46px', width: '250px', fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    /> */}
                                </Grid2>
                                
                                {/* <Grid2 item size={3}>
                                    <Select
                                        value={currency}
                                        onChange={(e) => setCurrency(e.target.value)}
                                        displayEmpty
                                        style={{ width: '220px', height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}
                                    >
                                        <MenuItem value="">Select Currency</MenuItem>
                                        {currencyList.map((cur) => (
                                            <MenuItem key={cur.code} value={cur.code}>
                                                {cur.name} ({cur.symbol})
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2> */}

                                {(updateGeofence && !modifyGeofence) && (
                                    <Grid2 item size={3}>
                                        {/* {selectedPolygon && ( */}
                                            <Button
                                                onClick={handleDrawPolygon}
                                                disabled={drawnPolygon || (customSquareGeofence && customSquareGeofence.length > 0)}
                                                sx={{textTransform:'none', border:'1px solid #0065ff', borderRadius:'8px', padding:'10px', height:'46px'}}
                                            >
                                                Draw Geofence
                                            </Button>
                                        {/* )} */}

                                        {(drawnPolygon || customSquareGeofence) && (
                                            <Button sx={{height:'46px', marginLeft:'4%'}}
                                                variant="contained"
                                                color="danger"
                                                onClick={handleDeletePolygon}
                                            >
                                                <DeleteIcon/>
                                            </Button>
                                        )}
                                    </Grid2>
                                )}

                                {(modifyGeofence) && (
                                    <Grid2 item size={3}>
                                         <Button
                                            onClick={handleModifyGeofence}
                                            sx={{textTransform:'none', border:'1px solid #0065ff', borderRadius:'8px', padding:'10px', height:'46px'}}
                                        >
                                            Modify Geofence
                                        </Button>
                                    </Grid2>
                                )}

                                <Grid2 item sx={{marginLeft:'auto'}}>
                                    <Button variant="contained" color="primary" onClick={handleAddCity} sx={{height:'46px', textTransform:'none', borderRadius:'6px'}} >Save New City</Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    )}
                    

                    <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={noCityMatch ? containerStyle2 : containerStyle} center={center} zoom={8} onLoad={onLoad} onUnmount={onUnmount}>
                                    {drawingMode && (
                                        <DrawingManager
                                            onLoad={onLoadDrawingManager}
                                            onPolygonComplete={onPolygonComplete}
                                            drawingMode={window.google.maps.drawing.OverlayType.POLYGON}
                                        />
                                    )}

                                    {isPolygonVisible && !noCityMatch && geofence.length > 0 &&
                                        geofence.map((polygon, index) => (
                                            <Polygon
                                                key={`polygon-${index}`} // Unique key for each polygon
                                                paths={polygon.map((point) => ({
                                                    lat: Number(point.x || point.lat),
                                                    lng: Number(point.y || point.lng)
                                                }))}
                                                options={{
                                                    fillColor: "rgba(255, 0, 0, 0.3)",
                                                    fillOpacity: 0.4,
                                                    strokeColor: "red",
                                                    strokeOpacity: 1,
                                                    strokeWeight: 2,
                                                }}
                                                onClick={handlePolygonClick} 
                                            />
                                        ))
                                    }

                                    {customSquareGeofence && noCityMatch && customSquareGeofence.length>0 && (
                                        <Polygon
                                            paths={customSquareGeofence.map((point) => ({
                                                lat: Number(point.lat),
                                                lng: Number(point.lng)
                                            }))}
                                            options={{
                                                fillColor: "rgba(255, 0, 0, 0.3)",
                                                fillOpacity: 0.4,
                                                strokeColor: "red",
                                                strokeOpacity: 1,
                                                strokeWeight: 2,
                                            }}
                                            onClick={handlePolygonClick}
                                        />
                                    )}
                            
                            </GoogleMap>
                        ): (<></>)}
                    </Grid2>
                    </div>
                {/* </div>
            </div> */}

            {showSuccessModal &&(
                <Box sx={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",alignItems: "center", zIndex: 1300,
                        backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center"
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px", alignItems: "center",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center", display: "flex", flexDirection: "column", 
                        }}
                    >
                        {/* <img src={CarDriver} alt="No drivers found"/> */}
                        <Box
                            sx={{
                                width: "100px", // Adjust size of the Lottie animation
                                height: "100px",
                                marginBottom: "18px", // Space between Lottie and cancel button
                            }}
                        >
                            <Lottie animationData={lootieAnimation} loop={true} />
                        </Box>
                        <Typography sx={{ fontSize: "24px", color: "#0065FF", marginBottom: "14px" }}>
                            Thanks For choosing Us!
                        </Typography>

                        <Typography sx={{ fontSize: "16px", color: "#83888E", marginBottom: "24px" }}>
                            Your demo credentials have been sent to your email.
                            <br/>
                            Check your inbox <span style={{color:'#4E545D'}}>(and spam folder just in case!)</span> to get started!
                        </Typography>

                        <Typography 
                        onClick={handleClosePopupModal}
                            sx={{cursor: "pointer",color: "#0065FF",fontWeight: "500",fontSize: "14px",textDecoration: "none",
                                "&:hover": {textDecoration: "underline"}
                            }}
                        >
                            Got It
                        </Typography>
                    </Box>
                </Box>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default AddCity;